import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/data";
import { Reveal, SectionLabel } from "@/components/Reveal";

export const Services = () => (
  <section id="services" className="relative mx-auto max-w-[1400px] px-6 sm:px-10 py-24 lg:py-36">
    <Reveal>
      <SectionLabel>What we do</SectionLabel>
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.02] max-w-2xl">
          Five disciplines, <span className="text-gradient">one studio.</span>
        </h2>
        <p className="max-w-sm font-body text-[var(--text-secondary)]">
          No hand-offs, no agencies stitched together. Strategy, story and engineering under one roof.
        </p>
      </div>
    </Reveal>

    <div data-testid="services-bento-grid" className="grid grid-cols-1 lg:grid-cols-6 auto-rows-[220px] gap-4 lg:gap-5">
      {SERVICES.map((s, i) => (
        <motion.div
          key={s.id}
          data-testid={`service-card-${s.id}`}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
          className={`group relative overflow-hidden rounded-3xl border border-[var(--border-subtle)] hover-card-glow ${s.span}`}
        >
          <img
            src={s.image}
            alt={s.title}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover opacity-35 transition-all duration-700 group-hover:opacity-55 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg-primary)] via-[var(--bg-primary)]/60 to-transparent" />
          <div className="pointer-events-none absolute -right-12 -top-12 z-[5] h-44 w-44 rounded-full blur-3xl opacity-0 transition-opacity duration-500 group-hover:opacity-70" style={{ background: "var(--accent-gradient)" }} />
          <div className="relative z-10 flex h-full flex-col justify-between p-6 lg:p-7">
            <div className="flex items-start justify-between">
              <span className="font-mono text-xs text-[var(--accent-primary)]">{s.no}</span>
              <ArrowUpRight className="text-[var(--text-muted)] transition-all duration-500 group-hover:text-[var(--accent-primary)] group-hover:-translate-y-1 group-hover:translate-x-1" size={22} />
            </div>
            <div>
              <h3 className="font-display text-xl lg:text-2xl font-bold mb-2">{s.title}</h3>
              <p className="font-body text-sm text-[var(--text-secondary)] max-w-md mb-4 opacity-0 -translate-y-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0 lg:opacity-100 lg:translate-y-0">
                {s.desc}
              </p>
              <div className="flex flex-wrap gap-2">
                {s.tags.map((t) => (
                  <span key={t} className="font-mono text-[10px] uppercase tracking-wider rounded-full border border-[var(--border-subtle)] px-3 py-1 text-[var(--text-muted)]">
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
